import { useEffect, useRef } from 'react';

/**
 * Хук возвращает предыдущее сохраненное между рендерами значение.
 *
 * @typeParam T - Тип значения.
 * @param value - Текущее значение.
 * @returns Предыдущее значение или undefined.
 */
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
